<template lang="html">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2>Список курсов</h2>
        <ext-table
          @select = "(id) => { selectedCourseId = id }"
          :fields="{
            name: { label: 'Название' },
            cost: { label: 'Стоимость' },
            shedule: { label: 'Расписание'},
            period: { label: 'Период' }
          }"

          :loadProxy = "{ url: 'api/course', method: 'get' }"
          :deleteProxy = "{ url: 'api/course/' + selectedCourseId, method: 'delete' }"
        >
          <template slot="createForm">
            <course-form
              :submitProxy = "{ url: 'api/course', method: 'put' }"
            />
          </template>
          <template slot="updateForm">
            <course-form
              :submitProxy = "{ url: 'api/course/' + selectedCourseId, method: 'post' }"
              :loadProxy = "{ url: 'api/course/' + selectedCourseId, method: 'get' }"
            />
          </template>
        </ext-table>
      </div>
    </div>
    <hr class="my-4">
    <div class="row">
      <div class="col-md-5">
        <h2>Модули курса</h2>
        <ext-table
          @select = "(id) => { selectedCourseId = id }"
          :fields="{
            name: { label: 'Название' },
            period: { label: 'Период' },
          }"

          :deleteProxy = "{ url: 'api/course/' + selectedCourseId, method: 'delete' }"
        >
          <template slot="createForm">
            <course-form
              :submitProxy = "{ url: 'api/course', method: 'put' }"
            />
          </template>
          <template slot="updateForm">
            <course-form
              :submitProxy = "{ url: 'api/course/' + selectedCourseId, method: 'post' }"
              :loadProxy = "{ url: 'api/course/' + selectedCourseId, method: 'get' }"
            />
          </template>
        </ext-table>
      </div>
      <div class="col-md-7">
        <h2>Таблица оплаты</h2>
        <ext-table
          @select = "(id) => { selectedCourseId = id }"
          :fields="{
            paymentPeriod: { label: 'Сроки оплаты' },
            month: { label: 'За месяц' },
            cost: { label: 'Сумма' }
          }"
          
          :deleteProxy = "{ url: 'api/course/' + selectedCourseId, method: 'delete' }"
        >
          <template slot="createForm">

          </template>
          <template slot="updateForm">

          </template>
        </ext-table>
      </div>
    </div>
    <hr class="my-4">
    <div class="row">
      <div class="col-12">
        <h2>Материалы к курсам</h2>
        <ext-table
          @select = "(id) => { selectedCourseId = id }"
          :fields="{
            name: { label: 'Название' },
            type: { label: 'Тип' }
          }"


          :deleteProxy = "{ url: 'api/course/' + selectedCourseId, method: 'delete' }"
        >
          <template slot="createForm">

          </template>
          <template slot="updateForm">

          </template>
        </ext-table>
      </div>
    </div>
  </div>
</template>

<script>
import ExtTable from '@/components/ExtTable'
import CreateAccountForm from '@/forms/CreateAccountForm'
import CourseForm from '@/forms/CourseForm'

export default {
  components: {
    ExtTable,
    CreateAccountForm,
    CourseForm
  },
  data () {
    return {
      selectedCourseId: ''
    }
  }
}
</script>

<style lang="css">
  .ww {
    min-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// CourseManage.vue?36567f2f